import React, { Component } from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getEntrySubTypes } from "../../services/generalLedgerService";

import { generateProjectSalaryReport } from "../../services/reportService";

import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table, Button, Message } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import auth from "../../services/authService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "../common/select";
import ReactToPrint from "react-to-print";
import ProjectMonthlyPrintReport from "./print/projectmonthly";

class ProjectSalaryReport extends Component {
  state = {
    startDate: new Date(),
    endDate: new Date(),
    projects: [],
    showSalaryForm: false,
    showError: false,
    showErrorGenerateSalry: false,
    salaries: [],
    open: false,
    openSingle: false,
    totalSalaryAmount: 0,
    month: "",
    project: "",
    grand: 0,
    grandHours: 0,
  };

  handleChangeStartDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({
      endDate: date,
    });
  };

  async componentDidMount() {
    this.setState({ blocking: true });
    this.loadProjects();
    this.setState({ blocking: false });
  }

  async loadProjects() {
    let params = {
      company: 1,
      entryType: "project",
    };
    const { data: res } = await getEntrySubTypes(params);

    this.setState({ projects: res.accounts });
  }

  doSubmit = async () => {
    try {
      // var event = new Date(this.state.startDate);
      // let startDate = JSON.stringify(event);
      // startDate = startDate.slice(1, 11);

      // event = new Date(this.state.endDate);
      // let endDate = JSON.stringify(event);
      // endDate = endDate.slice(1, 11);

      const month = document.getElementById("month").value;
      const projectID = document.getElementById("project_id").value;
      const year = document.getElementById("year").value;

      // if (projectID == "") {
      //   toast.warning("Please select project to continue.");
      //   this.setState({ blocking: false });
      //   return false;
      // }

      this.setState({
        showError: false,
        blocking: true,
      });

      const verifyData = {
        //startDate: startDate,
        //endDate: endDate,
        year: year,
        month: month,
        projectID: projectID,
      };

      const res = await generateProjectSalaryReport(verifyData);

      this.setState({
        showError: false,
        showSalaryForm: true,
        blocking: false,
        salaries: res.data.data,
        month: res.data.month,
        project: res.data.project,
        grand: res.data.grand,
        grandHours: res.data.grandHours,
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    if (auth.getCurrentUser().role != "salary-admin") {
      return "Your are authorized to perform this action.";
    }
    const { salaries } = this.state;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Project Salary Report</h1>

        <div className="grid salary-report-filters">
          <select name="year" id="year" className="input">
            <option selected value="">
              --Select Year--
            </option>
            <option value="2020">2020</option>
            <option value="2021">2021</option>
            <option value="2022">2022</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
            <option value="2027">2027</option>
            <option value="2028">2028</option>
            <option value="2029">2029</option>
            <option value="2030">2030</option>
          </select>
          <div></div>
          <select name="month" id="month" className="input">
            <option selected value="">
              --Select Month--
            </option>
            <option value="1">Janaury</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
          <div></div>
          <select
            name="project_id"
            id="project_id"
            selected={this.state.project_id}
            className="input"
            onChange={this.handleChangeVisaId}
          >
            {this.state.projects.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
          <div></div>
          <button className="btn btn--primary" onClick={this.doSubmit}>
            Submit
          </button>
        </div>

        <center>
          <div className="ui error form" style={{ width: "40%" }}>
            <Message
              negative
              style={{
                display: this.state.showError == true ? "block" : "none",
              }}
            >
              <Message.Header>Error</Message.Header>
              <p>Salary data not found for the dates specified.</p>
            </Message>
            <Message
              negative
              style={{
                display:
                  this.state.showErrorGenerateSalry == true ? "block" : "none",
              }}
            >
              <Message.Header>Error</Message.Header>
              <p>Salary already generted for the date specified.</p>
            </Message>
          </div>

          <div
            className="scrap-report"
            style={{
              display: this.state.showSalaryForm == true ? "block" : "none",
            }}
          >
            <div className="scrap-report__print">
              <ReactToPrint
                trigger={() => <a href="#">Print this out!</a>}
                content={() => this.componentRef}
              />
            </div>

            <ProjectMonthlyPrintReport
              salaries={salaries}
              month={this.state.month}
              project={this.state.project}
              grand={this.state.grand}
              grandHours={this.state.grandHours}
              ref={(el) => (this.componentRef = el)}
            />
          </div>
        </center>
      </BlockUi>
    );
  }
}

export default ProjectSalaryReport;
